import React, { Component } from 'react';
import Countdown from 'react-countdown';
//import Rating from '@material-ui/lab/Rating';
import StarRating from 'react-star-ratings';

const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';


export default class BookedEventsPage extends Component {
    constructor() {
        super()
        this.state = {
            start_time: '',
            rating: 3,
            map_array: [1, 2, 3]
        }

       // this.filterBtnArray = ['All','Upcoming','Ongoing','Completed','Cancelled'];

    }

    // changeRating = (newRating, name) => {
    //     this.setState({
    //         rating: newRating
    //     });
    // }


    HandleTime = (startTime) => {
        // alert(startTime)
        startTime = startTime.replace(/  /g, 'T')
        //img_path+ item.event_details[0].event_image.replace(',', '')
        //   console.log(startTime)
        const monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var hr = new Date(startTime).getHours();
        var date = new Date(startTime).getDate();
        //  console.log(date);
        var month = new Date(startTime).getMonth();
        //  console.log(month)
        // alert(hr)
        var min = new Date(startTime).getMinutes();
        //  console.log(min)
        let final;
        let finalDate;
        let finalDateTime;

        if (date < 10) {
            date = '0' + date;
            //   console.log(date)
            finalDate = date + ' ' + monthArray[month];
        }
        finalDate = date + ' ' + monthArray[month];



        if (hr > 12) {
            hr = hr - 12
            if (min < 10) {
                min = '0' + min;
            }
            if (hr < 10) {
                hr = '0' + hr;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }
        else if (hr === 12) {
            if (min < 10) {
                min = '0' + min;
            }
            final = hr + ':' + min + ' ' + 'PM';
        }

        else {
            if (min < 10) {
                min = '0' + min;
            }
            if (hr < 10) {
                hr = '0' + hr;
            }
            final = hr + ':' + min + ' ' + 'AM';
        }

        finalDateTime = finalDate + ',' + " " + final;
        return finalDateTime;
    }

    LeftTime = (leftTime) => {
        //alert(left);
        leftTime = leftTime.replace(/  /g, 'T');
        var curr_time = new Date();
        var startTime = new Date(leftTime);
        var diff = startTime.getTime() - curr_time.getTime()

        let diff_in_day = diff / (1000 * 60 * 60 * 24);
        let left_day_hours;
        if (diff_in_day >= 1) {
            left_day_hours = Math.ceil(diff_in_day) + ' ' + 'Days'
            return left_day_hours;
        }
        else {
            return diff;
        }
    }



    render() {
        return (
            <div className="booked-events-main-div">
                <div className="container-fluid">
                    <div className="booked-event-card-head">
                        <div className="booked-event-card-head-tick"><i class="fa fa-lg fa-check" aria-hidden="true"></i></div>
                        <div><h3>Your Booked Session</h3></div>
                    </div>
                    <div className="row">
                    <div class= "col-md-12 col-lg-12">
                    <div class="booked-events-filter-div">
                    {
                        this.props.filterBtnArray.map((item,i)=>(
                            <button type='button' class="btn" id={item} onClick={()=>this.props.FilterSession(item)}>{item}</button>
                        ))
                    }
                   
                   
                    </div>
                    
                    </div>
                        <div className="col-md-12 col-lg-12">


                            {this.props.myEventsList.length > 0 ?
                                this.props.myEventsList.map((item, i) => (

                                    item.status === 1 ?

                                        <div className="booked-events-card" >
                                            <div className="row">
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="booked-event-card-content" >
                                                        <div className="row">
                                                            <div className="col-5 col-sm-5 col-md-3 col-lg-3">
                                                                <div className="booked-event-card-content-img-div cursor" onClick={() => this.props.GetEventDetails(item.event_details[0].seo_url)}>
                                                                    <img src={img_path + item.event_details[0].event_image.replace(',', '')} alt="loading..." />

                                                                </div>
                                                            </div>
                                                            <div className="col-7 col-sm-7 col-md-5 col-lg-5">
                                                                <div className="booked-event-card-content-content-div cursor" onClick={() => this.props.GetEventDetails(item.event_details[0].seo_url)}>
                                                                    <h5>{item.event_details[0].event_name}</h5>
                                                                    <p>Start Time - {this.HandleTime(item.event_details[0].event_start_time)} </p>
                                                                </div>
                                                                <div className='booked-event-card-content-joinBtn-div-mobile'>
                                                                    {this.LeftTime(item.event_details[0].event_start_time) <= 0 && this.LeftTime(item.event_details[0].event_start_time) >= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                        <p>Session Started</p>
                                                                        :
                                                                        this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                            <p>Session End</p>
                                                                            //  alert(JSON.stringify(item))
                                                                            //     alert(this.LeftTime(item.event_details[0].event_start_time)+'=============='+item.event_details[0].event_start_time+"========"+3*60*60*1000+"=========")
                                                                            :
                                                                            this.LeftTime(item.event_details[0].event_start_time) <= 24 * 60 * 60 * 1000 ?
                                                                                <p>Starts in <Countdown date={Date.now() + this.LeftTime(item.event_details[0].event_start_time)} /></p>
                                                                                :
                                                                                <p>Starts in {this.LeftTime(item.event_details[0].event_start_time)}</p>
                                                                    }
                                                                    {this.LeftTime(item.event_details[0].event_start_time) >= 5 * 60 * 1000 ?
                                                                        <p class="cancel-booking cursor-pointer" onClick={()=>this.props.CancelBooking(item._id,item.event_details[0]._id)}>Cancel Booking</p>
                                                                        :
                                                                        this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 ?

                                                                            item.rating > 0 ?
                                                                                <div className="mobile-star">
                                                                                    <StarRating
                                                                                        name={item._id + ',' + item.event_details[0]._id}
                                                                                        rating={item.rating}

                                                                                        // disabled="true"
                                                                                        // changeRating={this.props.changeRating}
                                                                                        starSpacing="5px"
                                                                                        // rating={2.403}
                                                                                        starDimension="20px"
                                                                                        starHoverColor='rgb(230, 67, 47)'
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <div className="mobile-star">
                                                                                    <StarRating
                                                                                        name={item._id + ',' + item.event_details[0]._id}
                                                                                        rating={item.rating}
                                                                                        class="mobile-star"
                                                                                        // disabled="true"
                                                                                        changeRating={this.props.changeRating}
                                                                                        starSpacing="5px"
                                                                                        // rating={2.403}
                                                                                        starDimension="20px"
                                                                                        starHoverColor='rgb(230, 67, 47)'
                                                                                    />
                                                                                </div>
                                                                            :
                                                                            this.LeftTime(item.event_details[0].event_start_time) <= 5 * 60 * 1000 ?
                                                                                ''
                                                                                :

                                                                                this.LeftTime(item.event_details[0].event_start_time) < 0 ?
                                                                                    ''
                                                                                    :

                                                                                    <p class="cancel-booking cursor-pointer" onClick={()=>this.props.CancelBooking(item._id,item.event_details[0]._id)}>Cancel Booking</p>

                                                                    }

                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                                <div className="booked-event-card-content-joinBtn-div">
                                                                    {this.LeftTime(item.event_details[0].event_start_time) <= 0 && this.LeftTime(item.event_details[0].event_start_time) >= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                        <p>Session Started</p>
                                                                        :
                                                                        this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                            <p>Session End</p>
                                                                            //  alert(JSON.stringify(item))
                                                                            //     alert(this.LeftTime(item.event_details[0].event_start_time)+'=============='+item.event_details[0].event_start_time+"========"+3*60*60*1000+"=========")
                                                                            :
                                                                            this.LeftTime(item.event_details[0].event_start_time) <= 24 * 60 * 60 * 1000 ?
                                                                                <p>Starts in <Countdown date={Date.now() + this.LeftTime(item.event_details[0].event_start_time)} /></p>
                                                                                :
                                                                                <p>Starts in {this.LeftTime(item.event_details[0].event_start_time)}</p>
                                                                    }
                                                                    {this.LeftTime(item.event_details[0].event_start_time) > 5 * 60 * 1000 ?
                                                                        <button type="button" disabled="true" style={{ cursor: 'not-allowed' }} className="btn">Join Session</button>
                                                                        :
                                                                        this.LeftTime(item.event_details[0].event_start_time) <= 5 * 60 * 1000 && this.LeftTime(item.event_details[0].event_start_time) >= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                            <a href={item.event_details[0].join_url} target="_blank">
                                                                                <button type="button" className="btn">Join Now</button>
                                                                            </a>
                                                                            :
                                                                            this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 ?
                                                                                ''
                                                                                : <button type="button" disabled="true" style={{ cursor: 'not-allowed' }} className="btn">Join Session</button>}

                                                                    {this.LeftTime(item.event_details[0].event_start_time) >= 5 * 60 * 1000 ?
                                                                        <p class="cancel-booking cursor-pointer" onClick={()=>this.props.CancelBooking(item._id,item.event_details[0]._id)}>Cancel Booking</p>
                                                                        :
                                                                        this.LeftTime(item.event_details[0].event_start_time) <= -item.event_details[0].event_duration * 60 * 1000 ?

                                                                            item.rating > 0 ?
                                                                                <div className="desktop-star">
                                                                                    <StarRating
                                                                                        name={item._id + ',' + item.event_details[0]._id}
                                                                                        rating={item.rating}
                                                                                        //   class="star"
                                                                                        // disabled="true"
                                                                                        // changeRating={this.props.changeRating}
                                                                                        starSpacing="5px"
                                                                                        // rating={2.403}
                                                                                        starDimension="30px"
                                                                                        starRatedColor='rgb(230, 67, 47)'
                                                                                        starHoverColor='rgb(230, 67, 47)'
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <div className="desktop-star">
                                                                                    <StarRating
                                                                                        name={item._id + ',' + item.event_details[0]._id}
                                                                                        rating={item.rating}

                                                                                        // disabled="true"
                                                                                        changeRating={this.props.changeRating}
                                                                                        starSpacing="5px"
                                                                                        // rating={2.403}
                                                                                        starDimension="30px"
                                                                                        starRatedColor='rgb(230, 67, 47)'
                                                                                        starHoverColor='rgb(230, 67, 47)'
                                                                                    />
                                                                                </div>
                                                                            :
                                                                            this.LeftTime(item.event_details[0].event_start_time) <= 5 * 60 * 1000 ?
                                                                                ''
                                                                                :

                                                                                this.LeftTime(item.event_details[0].event_start_time) < 0 ?
                                                                                    ''
                                                                                    :

                                                                                    <p class="cancel-booking cursor-pointer" onClick={()=>this.props.CancelBooking(item._id,item.event_details[0]._id)}>Cancel Booking</p>

                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>


                                        :
                                        <div className="booked-events-card disable " >
                                            <div className="row">
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="booked-event-card-content" >
                                                        <div className="row">
                                                            <div className="col-5 col-sm-5 col-md-3 col-lg-3">
                                                                <div className="booked-event-card-content-img-div cursor" onClick={() => this.props.GetEventDetails(item.event_details[0].seo_url)}>
                                                                    <img src={img_path + item.event_details[0].event_image.replace(',', '')} alt="loading..." />

                                                                </div>
                                                            </div>
                                                            <div className="col-7 col-sm-7 col-md-5 col-lg-5">
                                                                <div className="booked-event-card-content-content-div cursor" onClick={() => this.props.GetEventDetails(item.event_details[0].seo_url)}>
                                                                    <h5>{item.event_details[0].event_name}</h5>
                                                                    <p>Start Time - {this.HandleTime(item.event_details[0].event_start_time)} </p>
                                                                </div>
                                                                <div className='booked-event-card-content-joinBtn-div-mobile'>
                                                                {item.event_details[0].event_status === 2 ?
                                                                
                                                                <p class="cancel-booking">Session Cancelled</p>

                                                                :
                                                                <p class="cancel-booking">Booking Cancelled</p>
                                                            }
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                                                            <div className="booked-event-card-content-joinBtn-div">
                                                            {item.event_details[0].event_status === 2 ?
                                                                
                                                                <p class="cancel-booking">Session Cancelled</p>

                                                                :
                                                                <p class="cancel-booking">Booking Cancelled</p>
                                                            }
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>


                                ))

                                :

                                <div className='booked-events-message'>
                                    <p>Nothing in your my sessions list yet !!!</p>
                                    <button type='button' className='btn' onClick={() => this.props.HandleRouting('upcoming-sessions')}>Go to Session List</button>
                                </div>


                            }

                        </div>

                        <div className="col-md-12 col-lg-12">
                            <div className="kinship-helpline-div">
                                <div className="row">
                                    <div class="col-md-4 col-lg-4">
                                        <div class="kinship-helpline-content-div div1">
                                            <h5>Need Help</h5>
                                        </div>
                                    </div>
                                    <div class="col-12 sepration">
                                        <div className='seperation-div'>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="kinship-helpline-content-div div2">
                                            <div style={{ display: 'flex' }}>
                                                <h5>Call Us</h5>
                                                <p>8 AM to 8 PM</p>
                                            </div>
                                            <a href='tel:+918887757417'>
                                                <h5>8887757417</h5>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="kinship-helpline-content-div div3">
                                            <h5>Email Us</h5>
                                            <a href='mailto:kinship@gmail.com'>
                                                <h5>kinship@gmail.com</h5>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        )
    }
}

